const expData = [
  {
    id: "1",
    org: "Sylhet IT Academy",
    title: "Front End Developer",
    date: "Mar 2020 - Dec 2022",
    description:
      "In this role, I design wireframes and create frontend pages from ideation to development. I blend creativity with technical expertise to deliver compelling user experiences. My focus spans from initial brainstorming sessions to the final polish of the user interface. I also collaborate with other team members to ensure seamless project execution.",
  },
  {
    id: "2",
    org: "CMBD",
    title: "Junior Web Designer",
    date: "Dec 2022 - Sep 2023",
    description:
      "Built responsive design layouts for German clients, created custom interactions and animations, enhancing user engagement. Collaboratively plan with global teams for design and feature updates and ensured end-to-end product's quality checks, and timely delivery.",
  },
  {
    id: "3",
    org: "Web Studio",
    title: "MERN Stack Developer",
    date: "Jan 2023 - Feb 2024",
    description:
      "I was responsible for the programming of data to be entered on the system built with Microsoft ASP.NET framework. I conducted thorough research and analysis to identify areas for innovation and improvement. Collaborated effectively with cross functional teams to drive the enhancement of the system and user experience.",
  },
  {
    id: "4",
    org: "Freelance",
    title: "ReactJS Developer",
    date: "Since 2021",
    description:
      "I have successfully worked in MERN stack and Nextjs gaining expertise in both frontend and backend development. I have also actively contributed to the testing of Node applications, ensuring high-quality deliverables. Utilizing Agile methodology, I effectively collaborate with teams to enhance productivity and ensure seamless project execution.",
  },
  // {
  //   id: "5",
  //   org: "Freelance",
  //   title: "Graphic Designer",
  //   date: "2018 - 2020",
  //   description:
  //     "As a freelance graphic designer, I have worked independently and collaborated with clients to create visually appealing and impactful designs ideas, and deliver high-quality visual solutions that meet their needs. I have managed my schedule while ensuring timely project delivery and maintaining client satisfaction. ",
  // },
];

export default expData;